export const TriggerTypeEnum = {
    TIMELINE: 'Timeline',
    EVENT: 'Event'
};

export const ActionTypeEnum = {
    PLAY_AUDIO: 'PlayAudio',
    LOAD_VIEWPOINT: 'LoadViewpoint',
    VR_INFORMATION: 'VRInformation',
    COMMAND_ACTION: 'CommandAction',
    SELECT_ONE_OPTION: 'SelectOneOption',
    LOAD_STATE: 'LoadState',
    LOAD_TIMELINE: 'LoadTimeline',
    LOAD_EVENTS: 'LoadEvents',
    NO_OPERATION: 'NoOperation',
    PRUNE: 'Prune',
    MODEL_SELECT: 'ModelSelect',
    VOLUME_SELECT: 'VolumeSelect',
    BRANCH_SELECT: 'BranchSelect',
    GROUP_SELECT: 'GroupSelect',
    MOVE_VOLUME: 'MoveVolume',
    MOVE_MODEL: 'MoveModel',
    MOVE_BRANCH: 'MoveBranch',
    MOVE_GROUP: 'MoveGroup',
    EXPLODE_MODEL: 'ExplodeModel',
    EXPLODE_SCENE: 'ExplodeScene',
    SCENE_TRANSFORMATION: 'SceneTransformation',
    GLB_ANIMATION: 'GlbAnimation',
    PLAY_ANIMATION: 'PlayAnimation',
    PAUSE_ANIMATION: 'PauseAnimation',
    STOP_ANIMATION: 'StopAnimation',
    UPDATE_MENU_ACTION: 'UpdateMenuAction',
    USER_ACTION_MOVE_OBJECTS: 'UserActionMoveObjects',
    TEXT_SCRIPT: 'TextScript',
    MEETING_CONFIGURATIONS: 'MeetingConfigurations',
    MEDIA_SCREEN_SHOW: 'MediaScreenShow',
    MEDIA_SCREEN_PLAY: 'MediaScreenPlay',
    MEDIA_SCREEN_CURRENT_TIME: 'MediaScreenCurrentTime',
    MEDIA_SCREEN_CHANGE_PAGE: 'MediaScreenChangePage',
    MEDIA_SCREEN_FOCUS: 'MediaScreenFocus',
    MEDIA_SCREEN_SELECT: 'MediaScreenSelect',
    HIGHLIGHT: 'Highlight',
    TRANSPARENCY: 'Transparency',
    VISIBILITY: 'Visibility',
    RESET_MODEL: 'ResetModel',
    WORKSPACE_TERMINATION: 'WorkspaceTermination',
    ALIGN_WITH_PHYSICAL: 'AlignWithPhysical',
    WAYFINDING: 'Wayfinding',
    External_Signal_Receiver: 'ExternalSignalReceiver',
    FLASH: 'Flash',
    TRACK_TIME: 'TrackTime',
    GET_TIME_DURATION: 'GetTimeDuration',
    STEP_INSTRUCTION_MENU: 'StepInstructionMenu',
    ADD_MENU: 'AddMenu',
};

export const ResourceTypeEnum = {
    CAMERA: 'camera',
    SCENE: 'scene',
    ANIMATION: 'animation',
    MEDIA_SCREEN: 'mediascreen',
    STYLE: 'style',
    BOUNDARY: 'Boundary',
    MODEL: 'Model',
    HELPER_OBJECT: 'HelperObject',
};

export const FlashOperationTypes = [ActionTypeEnum.HIGHLIGHT, ActionTypeEnum.VISIBILITY, ActionTypeEnum.TRANSPARENCY];

export function updateWorkspaceFeatures() {
    CommandPromptManager.removeAllCommands();
    modelManager.stopAllAnimation();
    AnimationPlayer.stopAllAnimations();

    InstructionManager.RemoveAllInstructionMenus(true);

    wv.effectController.lockUserMovement = false;
    VR.mouseControls.enablePan = true;

    wv.effectController.lockUserOrientation = false;
    VR.mouseControls.enableRotate = true;

    if (keyboardController.isKeyBoardVisible()) {
        keyboardController.closeKeyboard();
    }

    const prompt = wv.promptWindowList.find(prompt => prompt.options?.name === 'training');
    if (prompt) {
        prompt.destroy();
    }

    wv.trainingSplashScreen?.dispose();

    VRInformationController.removeAllMessage();
    VRMessageController.removeAllMessage();

    PickerManager.removeAllPicker();
}

export function applyPruneToTimelineItem(timelineItem, globalPrune) {
    const item = {...timelineItem};
    if (!item.hasOwnProperty('prune') && globalPrune !== undefined && globalPrune !== null) {
        item.prune = globalPrune;
    }
    return item;
}
